import React from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {TISSUE_OPTIONS} from "../constants";

function TissueSelect({ tissue, setTissue }) {
  return (
      <Box sx={{ display: "flex", alignItems: "center", padding: 1 }}>
      <Typography  component="h3" variant="h6" draggable={false} sx={{ mr: 8 }}>
        Тип ИНС:
      </Typography>
        <FormControl sx={{ m: 1, minWidth: 200 }} variant="outlined">
          <Select
              displayEmpty
              labelId="tissue-select-label"
              id="tissue-select"
              value={tissue}
              onChange={(event) => setTissue(event.target.value)}
              sx={{ height: 56, minWidth: 200 }}
              renderValue={(selected) => {
                  if (!selected) return <em style={{color: '#999'}}>Без разметки (только конвертация)</em>;
                  const opt = TISSUE_OPTIONS.find(o => o.value === selected);
                  return opt ? opt.label : selected;
              }}
          >
            <MenuItem value=""><em>Без разметки (только конвертация)</em></MenuItem>
            {TISSUE_OPTIONS.map(opt => (
                <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
            ))}
          </Select>
        </FormControl>
    </Box>
  );
}

export default TissueSelect;
